import React, { useEffect, useCallback, useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
// styles
import useStyles from "./styles";
import { getMuiTheme } from "./styles";
import {DialogTitle, Dialog,useTheme } from '@material-ui/core';
import { editDashlet } from "../../../../store/actions/dashboard.actions";
import { toast } from "react-toastify";
import { EditPopupData } from "./components";
import CircularProgress from '@material-ui/core/CircularProgress';
import { pathOr } from "ramda";
import { MuiThemeProvider } from "@material-ui/core/styles";
export default function FormDialog({ data, openEditDialog, setOpenEditDialog, setConfiguredDashlet, configuredDashlet ,addDashlet,value}) {
    const { editDashletLoading, configureDashletLoading } = useSelector((state) => state.dashboard);
    const classes = useStyles();
    const currentTheme = useTheme();
  
    // const [toast, setToast] = useState({ toastVisible: false, toastMessage: '' });
    const { isAuthenticated } = useSelector((state) => state.auth);
    const [editDashletData, setEditDashletData] = useState(null);
    const dispatch = useDispatch();
    const getEditDashletData = useCallback(
        () => isAuthenticated && dispatch(editDashlet(data)).then(function (res) {
            if (res.ok) {
                setEditDashletData(res.data)
            } else {
                toast('Something went wrong!');
                setOpenEditDialog(false);
            }
        }),
        [dispatch, data, isAuthenticated],
    );
    useEffect(() => {
        getEditDashletData()
    }, []);
    let module = pathOr('', ['data', 'module'], data);
    const handleClickOpen = () => {
        setOpenEditDialog(true);
    };
    const handleClose = () => {
        setOpenEditDialog(false);
    };
    return (
        <>
            <MuiThemeProvider theme={getMuiTheme(currentTheme)}>
            <Dialog fullWidth={!editDashletLoading && editDashletData ?true:false} maxWidth={"md"} open={openEditDialog} onClose={handleClose} aria-labelledby="form-dialog-title" >
                {!editDashletLoading && editDashletData ?
                    <EditPopupData data={data} editDashletData={editDashletData} module={module} openEditDialog={openEditDialog} setOpenEditDialog={setOpenEditDialog} setConfiguredDashlet={setConfiguredDashlet} configuredDashlet={configuredDashlet} addDashlet={addDashlet} value={value}/>

                    : <DialogTitle id="form-dialog-title"><CircularProgress />
                    </DialogTitle>
                }
            </Dialog>
            </MuiThemeProvider>
        </>
    );
}